
"use client";

import { Link } from "@/i18n/navigation";
import { CustomForm } from "@/components/forms";
import { useTranslations } from "next-intl";

function BookADemo() {
	const t = useTranslations();
	
	return (
		<main className="relative top-0 flex size-full max-h-screen min-h-[600px] flex-col md:flex-row">
			<div className="hidden md:block bg-[#1B1B1B] /overflow-x-hidden h-[900px] min-h-screen w-full md:w-1/2">
				<div className="relative z-50 w-full flex justify-start pt-4 pb-4 md:pt-10 md:pb-5 px-8 md:px-10">
					<div className="w-[200px]">
						<Link href={"/"} aria-label="Go to StudyStash Homepage">
							<img src="/StudyStash_Logo_White.png" alt="StudyStash Logo" className="w-full h-auto"></img>
						</Link>
					</div>
				</div>

				<div className="w-full flex-1 z-40 flex flex-col items-center justify-center bg-[#1B1B1B] px-8">
					<div className="relative">
						<img
							src="/book-a-demo/output-3.png"
							alt="Visualisation of 10,000+ students learning with StudyStash"
							className="rounded-3xl"
							width={470}
							height={340}
						></img>
					</div>

					<div className="max-w-[470px] mx-auto pt-10 text-center">
						<div className="flex flex-col space-y-4">
							<h1 className="sr-only font-bold tracking-tight text-white">Empower Your Students to Succeed</h1>
							<h2 className="font-bold tracking-tight not-sr-only text-white">
								Empower Your Students to Succeed
							</h2>

							<p className="mt-3 text-sm text-white text-md sm:text-base">
								Give your students the {t("general.words.personalised")} support they need to thrive. StudyStash helps boost engagement, confidence, and outcomes-schedule a demo to see it in action.
							</p>
						</div>
					</div>

					<div className="flex w-full justify-center pt-10">
						<div className="h-[0.5px] max-w-md w-full bg-gray-400"></div>
					</div>

				</div>
			</div>

			<div id="demo-form" className="flex h-[900px] min-h-screen w-full grow flex-col items-center justify-center bg-ss-lightest-blue px-5 pt-10 /py-10 lg:px-20 md:w-1/2 md:px-5 md:pt-0 sm:px-20">
				<CustomForm formId="b1000-book-a-demo" />
			</div>
		</main>
	);
}

export default BookADemo;
